var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoQuoteRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0c7.18 0 13 4.836 13 10.8 0 5.965-5.82 10.8-13 10.8-1.268 0-2.489-.158-3.647-.438L2.363 24l1.317-5.68C1.406 16.375 0 13.726 0 10.8 0 4.836 5.82 0 13 0zm0 1.2c-6.516 0-11.818 4.307-11.818 9.6 0 2.46 1.157 4.805 3.26 6.602.34.291.49.752.388 1.193l-.795 3.434 4.88-1.982a1.15 1.15 0 0 1 .713-.053c1.111.27 2.246.406 3.372.406 6.517 0 11.818-4.307 11.818-9.6 0-5.293-5.301-9.6-11.818-9.6zm5.571 9.36c-.43 1.652-1.237 3.757-1.744 4.662l-1.051.138c.412-1.161.9-3.207 1.108-4.623l1.687-.177zm-2.776 0c-.432 1.652-1.238 3.757-1.745 4.662L13 15.36c.393-1.161.9-3.207 1.106-4.623l1.689-.177zM13 6.72c-.411 1.161-.897 3.187-1.103 4.603l-1.684.197c.413-1.652 1.235-3.777 1.74-4.682L13 6.72zm-2.767 0c-.41 1.161-.898 3.187-1.103 4.603l-1.701.197c.43-1.652 1.233-3.777 1.757-4.682l1.047-.118z",
    fill: "#222220",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuoteRequest);
export default __webpack_public_path__ + "static/media/ico-quote-request.0a650944.svg";
export { ForwardRef as ReactComponent };